module.exports = __webpack_public_path__ + "img/promobox_03.be125b7a.svg";